import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { AdminApi, AdminApiConnection } from 'api';
import useApiCall from 'hooks/use-api-call';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';

interface DeleteApiConnectionModalProps {
  onDelete: () => void;
  onClose: () => void;
  apiConnection: AdminApiConnection;
}

const DeleteApiConnectionModal: FunctionComponent<DeleteApiConnectionModalProps> = ({
  onDelete,
  onClose,
  apiConnection,
}) => {
  const { makeAuthenticatedApi, withApi } = useApiCall();
  const adminApi: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const onSubmit = useCallback(() => {
    withApi(async () => {
      await adminApi.adminApiConnectionsDestroy({ id: apiConnection.id });

      onDelete();
    });
  }, [apiConnection]);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name={'deleteApiConnectionModal.title'} />
      </ModalHeader>
      <ModalContent>
        <Translate name="deleteApiConnectionModal.content" args={[<strong>{apiConnection.name}</strong>]} />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.cancel" />,
              size: 'large',
              onClick: () => onClose(),
            },
            {
              name: 'send',
              onClick: () => onSubmit(),
              content: <Translate name="common.delete" />,
              variant: 'primary',
              type: 'submit',
              size: 'large',
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteApiConnectionModal;
